import styled, { keyframes } from "styled-components";

import { variables } from "politicamente-informados-ds";

export const StyledHeader = styled.div`
  /* position: sticky; */
  position: relative;
  /* top: 0;
  left: 0; */
  width: 100%;

  z-index: 100;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 16px;
  padding: 16px;


  button{
    margin-right:0;
  }
  
  .header-absolute & {
    position: fixed;
    
    background-color: transparent;
    transition: background-color 0.3s linear;

    .style-dark & {
      color: white;
    }
    .style-light & {
      color: ${variables.colors.gray100};
    }

    &.scrolled {
      .style-light & {
        color: ${variables.colors.error};
        background-color: white;
      }
      .style-dark & {
        color: red;
        background-color: ${variables.colors.primary70};
      }
    }
  }
  .header-absolute.style-light & {
    &.scrolled {
      color: ${variables.colors.gray100};
      background-color: white;
    }
  }
  .header-absolute.style-dark & {
    &.scrolled {
      color: white;
      background-color: ${variables.colors.gray100};
    }
  }
`;

export const gradientAnimation = keyframes`
  0% {
    background-position: 0% 50%;
  }
  50% {
    background-position: 100% 50%;
  }
  100% {
    background-position: 0% 50%;
  }
`;

export const StyledNav = styled.nav`
  ul {
    display: flex;
    align-items: center;
    gap: 32px;
    font-weight: bold;
    list-style: none;
    li {
      transition: all 300ms;
      cursor: pointer;
      &:hover {
        transition: all 300ms;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: linear-gradient(
          90deg,
          var(--color-primary50),
          var(--color-secondary50)
        );
        animation: ${gradientAnimation} 1s ease;
        background-size: 150% 150%;
      }

      &.active{
        transition: all 300ms;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        background-image: linear-gradient(
          90deg,
          var(--color-primary50),
          var(--color-secondary50)
        );
        animation: ${gradientAnimation} 1s ease;
        background-size: 150% 150%;
      }
    }
  }
`;
